export default __webpack_public_path__ + "static/lutein-vijdame-header-ef0697deea736e406c863e63e7b1a19b.mp4";